/** @prettier */

/**
 * weatherAPI関連関数一覧
 */

//interface import
import * as apiIF from '../Type/api';

/**
 * weatherAPIのクエリ用言語を取得
 * @param language 取得したい言語
 * @returns クエリ用言語
 */
const getLanguageForAPIQuery = (
  language: apiIF.res.getSettingUser['language']
) => {
  switch (language) {
    case 'english':
      return 'en';
    case 'german':
      return 'de';
    case 'dutch':
      return 'nl';
    case 'italian':
      return 'it';
    case 'spanish':
      return 'es';
    case 'french':
      return 'fr';
    case 'greek':
      return 'el';
    case 'polish':
      return 'pl';
    case 'portuguese':
      return 'pt';
    case 'turkish':
      return 'tr';
    case 'custom':
      return 'en';
    default:
      return 'en';
  }
};

export {getLanguageForAPIQuery};
